// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "4b4d9bbd6ce962cccc6350e3e326d991b2f1e9b0/static/css/" + chunkId + "." + "f83a2947" + ".chunk.css";
};